<template>
    <ul class="pagination">
      <li v-if="currentPage > 1">
        <a href="#" @click.prevent="changePage(currentPage - 1)" :style="`${disabled ? 'user-select: none; opacity: .5' : ''}`">Anterior</a>
      </li>
      <li v-for="button in buttons" :key="button.key">
        <a 
          v-if="button.text !== '...'" 
          href="#" 
          @click.prevent="changePage(button.text)" 
          :style="`${disabled ? 'user-select: none; opacity: .5' : ''}`"
        >
          {{ button.text }}
        </a>
        <span v-else :style="`user-select: none; ${disabled ? ' opacity: .5' : ''}`">...</span>
      </li>
      <li v-if="currentPage < totalPages">
        <a href="#" @click.prevent="changePage(currentPage + 1)" :style="`${disabled ? 'user-select: none; opacity: .5' : ''}`">Siguiente</a>
      </li>
    </ul>
</template>

<script>
import generatePaginationButtons from './utils/generatePaginationButtons';

export default {
  props: {
    currentPage: {
      type: Number,
      required: true
    },
    total: {
      type: Number,
      required: true
    },
    perPage: {
      type: Number,
      required: true
    },
    maxVisibleButtons: {
      type: Number,
      default: 7
    },
    disabled: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    totalPages() {
     return Math.ceil(this.total / this.perPage);
    },
    hasPreviousPage() {
      return this.currentPage > 1;
    },
    hasNextPage() {
      return this.currentPage < this.totalPages;
    },
    buttons() {
      try {
        if(this.total === 0) return []
        if(this.currentPage == 1 && this.total <= this.perPage) return [{ key: 1, text: 1 }]

        return generatePaginationButtons(this.currentPage, this.total, this.perPage, this.maxVisibleButtons);        
      } catch (error) {
        return []        
      }
    }
  },
  methods: {
    changePage(page) {
      this.$emit('change', page);
    }
  }
}
</script>